import React from "react";
import PropTypes from "prop-types";
import {
  Transition,
  Dimmer,
  Container,
  Segment,
  Header,
  Form,
  Button
} from "semantic-ui-react";

class InputData extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      valor: this.props.value
    };
  }

  saveModal = () => this.props.saveModal(this.props.nombre, this.state.valor);

  render() {
    return (
      <Transition
        unmountOnHide
        visible={this.props.show}
        animation="scale"
        duration={200}
      >
        <Dimmer page active={this.props.show}>
          <Container text>
            <Segment>
              <Header as="h2" color="pink">
                <Header.Content>{this.props.titulo}</Header.Content>
              </Header>
              <Segment basic textAlign="center">
                <Form>
                  <Form.Group widths="1">
                    <Form.Input
                      id="datos"
                      name="datos"
                      value={this.state.valor}
                      onChange={(e, {value}) => this.setState({ valor: value })}
                    />
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Button
                      basic
                      negative
                      labelPosition="right"
                      icon="cancel"
                      content="Cancelar"
                      onClick={this.props.closeDialog}
                    />
                    <Button
                      basic
                      positive
                      labelPosition="right"
                      icon="checkmark"
                      content="Guardar"
                      onClick={this.saveModal}
                    />
                  </Form.Group>
                </Form>
              </Segment>
            </Segment>
          </Container>
        </Dimmer>
      </Transition>
    );
  }
}

InputData.propTypes = {
  titulo: PropTypes.string,
  nombre: PropTypes.string,
  value: PropTypes.any,
  show: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  saveModal: PropTypes.func.isRequired
};

InputData.defaultProps = {
  titulo: "Introduzca un valor",
  show: true
};

export default InputData;



// WEBPACK FOOTER //
// ./src/pages/shared/InputData.jsx